import React from 'react';
import PropTypes from 'prop-types';
/**
 * @license below directly imported to attribute code adapted from their repository
 * Code below adapted from https://github.com/civiccc/react-simple-pie-chart
 * License can be found below as well as at https://github.com/civiccc/react-simple-pie-chart/blob/master/LICENSE
 * The MIT License (MIT)
 * Copyright (c) 2015 Brigade
 * When this comment is no longer removed by minify step, import below can be removed
 */
// TODO: I couldn't get this to work locally
// eslint-disable-next-line
// import reactSimplePieChartLicense from 'react-simple-pie-chart/LICENSE';

const size = 100;
const radCircumference = Math.PI * 2;
const center = size / 2;
const radius = center - 5;

const renderPaths = (slices) => {
  const total = slices.reduce((totalValue, { value }) => totalValue + value, 0);

  let radSegment = 0;
  let lastX = radius;
  let lastY = 0;

  return slices.map(({ color, value }) => {
    if (value === total) {
      return (
        <circle
          r={radius}
          cx={center}
          cy={center}
          fill={color}
          stroke={color}
          key={color}
        />
      );
    }

    if (value === 0) { return null; }

    const valuePercentage = value / total;

    const longArc = (valuePercentage <= 0.5) ? 0 : 1;

    radSegment += valuePercentage * radCircumference;
    const nextX = Math.cos(radSegment) * radius;
    const nextY = Math.sin(radSegment) * radius;

    const d = [
      `M ${center},${center}`,
      `l ${lastX},${-lastY}`,
      `a${radius},${radius}`,
      '0',
      `${longArc},0`,
      `${nextX - lastX},${-(nextY - lastY)}`,
      'z',
    ].join(' ');

    lastX = nextX;
    lastY = nextY;

    return <path d={d} fill={color} stroke={color} key={color} />;
  });
};

const DonutChart = ({
  className = '',
  borderColor = '#fff',
  slices = [],
  ...otherProps
}) => {

  return (
    <div className={className} {...otherProps}>
      <svg viewBox={`0 0 ${size} ${size}`}>
        <g transform={`rotate(270 ${center} ${center})`}>
          <circle r={radius + 1} cx={center} cy={center} fill="#fff" stroke={borderColor} />
          {renderPaths(slices)}
        </g>
        <svg viewBox={`-75 -75 ${size * 2.5} ${size * 2.5}`}>

          <g transform={`rotate(-90 ${center} ${center})`}>
            <circle r={radius + 19} cx={center} cy={center} fill="#fff" stroke={borderColor} strokeWidth={2} />
            <circle r={radius + 15} cx={center} cy={center} fill="#fff" />
          </g>
        </svg>
      </svg>
    </div>
  );
};

DonutChart.propTypes = {
  slices: PropTypes.arrayOf(PropTypes.shape({
    color: PropTypes.string,
    value: PropTypes.number,
  })),
  borderColor: PropTypes.string,
  className: PropTypes.string,
};



export default DonutChart;